import * as React from 'react'
import bugsnagClient from '../../bugsnag-client'

export const ErrorBoundary = bugsnagClient
  .getPlugin('react')!
  .createErrorBoundary(React)
